module.exports = __webpack_public_path__ + "envelope-check.dfd87e1b09ca08e91adb4c9adee2fe67.svg";